/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media (min-width:1024px){.desktop-only-disclaimer-container[_ngcontent-%COMP%]{position:relative;width:672px}}\n/*# sourceMappingURL=ai-complete-enrollment.component.css.map*/"];
export { styles as styles };
